import React from 'react';
import styled from 'styled-components';

// Импортируем изображения телефонов
import Phone1 from 'static/images/landingMarketPlace/mobileBottom.webp';
import Phone2 from 'static/images/landingMarketPlace/mobileTop.webp';

export const AssistantSection = ({ refProp }) => {
    return (
        <AssistantWrapper ref={refProp}>
            <Title>Персональный ассистент для покупателя</Title>

            <ContentContainer>
                <TextContent>
                    <IntroText>
                        Ищете способ повысить конверсию и упростить поддержку
                        клиентов? Чат-бот от{' '}
                        <SpodialHighlight>Spodial</SpodialHighlight> — это умный
                        ИИ-помощник, который:
                    </IntroText>

                    <FeaturesList>
                        <FeatureItem>
                            <Bullet />
                            <FeatureText>
                                Обрабатывает даже самые сложные запросы и
                                формирует индивидуальные подборки для каждого
                                покупателя
                            </FeatureText>
                        </FeatureItem>
                        <FeatureItem>
                            <Bullet />
                            <FeatureText>
                                Отвечает на все вопросы о товарах, экономя время
                                и снижая нагрузку на поддержку
                            </FeatureText>
                        </FeatureItem>
                        <FeatureItem>
                            <Bullet />
                            <FeatureText>
                                Собирает и передает данные о клиентах напрямую в
                                вашу CRM для дальнейшего анализа
                            </FeatureText>
                        </FeatureItem>
                    </FeaturesList>

                    <CallToAction>
                        Внедрите чат-бот Spodial, чтобы упростить путь клиента к
                        покупке и увеличить продажи!
                    </CallToAction>
                </TextContent>

                <PhonesContainer>
                    <PhoneImage
                        src={Phone1}
                        alt='Spodial assistant interface'
                    />
                    <PhoneImage src={Phone2} alt='Spodial assistant chat' />
                </PhonesContainer>
            </ContentContainer>
        </AssistantWrapper>
    );
};

const AssistantWrapper = styled.section`
    padding: 80px 0;
    width: 100%;
`;

const ContentContainer = styled.div`
    max-width: 1160px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    gap: 48px;
    align-items: center;

    @media (max-width: 992px) {
        flex-direction: column;
    }
`;

const Title = styled.h2`
    font-size: 34px;
    font-weight: 700;
    line-height: 1.2;
    color: #1a1a1a;
    margin: 0 0 48px;
    font-family: 'Unbounded';

    @media (max-width: 992px) {
        font-size: 28px;
        text-align: center;
        margin-bottom: 32px;
        br {
            display: none;
        }
    }
`;

const TextContent = styled.div`
    flex: 1;
    max-width: 560px;

    @media (max-width: 992px) {
        max-width: 100%;
        order: 2;
    }
`;

const PhonesContainer = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 24px;

    @media (max-width: 992px) {
        order: 1;
        flex-wrap: nowrap;
    }
`;

const PhoneImage = styled.img`
    max-width: 300px;
    height: auto;
    border-radius: 24px;

    @media (max-width: 768px) {
        max-width: 200px;
        width: 280px;
    }
`;

const IntroText = styled.p`
    font-size: 20px;
    line-height: 1.5;
    color: #1a1a1a;
    margin-bottom: 32px;

    @media (max-width: 768px) {
        font-size: 18px;
        text-align: center;
    }
`;

const SpodialHighlight = styled.span`
    font-weight: 700;
`;

const FeaturesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 32px;
`;

const FeatureItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 16px;

    @media (max-width: 768px) {
        align-items: center;
    }
`;

const Bullet = styled.div`
    width: 12px;
    height: 12px;
    min-width: 12px;
    background: #7c3aed;
    border-radius: 50%;
    margin-top: 8px;

    @media (max-width: 768px) {
        margin-top: 0;
    }
`;

const FeatureText = styled.p`
    font-size: 18px;
    line-height: 1.5;
    color: #1a1a1a;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const CallToAction = styled.p`
    font-size: 20px;
    line-height: 1.5;
    color: #1a1a1a;
    font-weight: 600;
    margin: 32px 0 0;

    @media (max-width: 768px) {
        font-size: 18px;
        text-align: center;
    }
`;
